import Vue from 'vue';
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import Vuetify from 'vuetify'
import locale from 'element-ui/lib/locale/lang/en'
import BlockUIService from './Shared/BlockUIService.js';
import App from './App.vue';
import Layout from './components/Layout/Layout.vue';
import Login from './components/Login/Login.vue';
import Home from './components/Home/Home.vue';
import DataService from './Shared/DataService';
import Profile from './components/Users/EditUsersProfile/EditUsersProfile.vue'
import Users from './components/Users/Users.vue';
import AddUsers from './components/Users/AddUsers/AddUsers.vue';
import ChangePassword from './components/Users/ChangePassword/ChangePassword.vue';

import Hospitals from './components/Hospitals/Hospitals.vue';
import AddHospitals from './components/Hospitals/Add/Add.vue';

import Municipalities from './components/Municipalities/Municipalities.vue';
import AddMunicipalities from './components/Municipalities/Add/Add.vue';

import Applications from './components/Applications/Applications.vue';
import AddApplications from './components/Applications/Add/Add.vue';
import Request from './components/Request/Request.vue';


import VueEllipseProgress from 'vue-ellipse-progress';

Vue.use(VueEllipseProgress);

Vue.use(Vuetify)
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;


export const eventBus = new Vue();

//const i18n = new VueI18n({
//    locale: 'ar', // set locale
//    messages, // set locale messages
//})

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    linkActiveClass: 'active',
    routes: [
        {
            path: '/Login',
            component: Login,
         
        },
         {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    component: Layout,
                    children: [
                        { path: '', component: Home },
                        { path: 'Profile', component: Profile },
                        { path: 'Users', component: Users },
                        { path: 'Users/AddUsers', component: AddUsers },
                        { path: 'ChangePassword', component: ChangePassword },
                        { path: 'Hospitals', component: Hospitals },
                        { path: 'Hospitals/AddHospitals', component: AddHospitals },
                        { path: 'Applications', component: Applications },
                        { path: 'Applications/AddApplications', component: AddApplications },
                        { path: 'Municipalities', component: Municipalities },
                        { path: 'Municipalities/AddMunicipalities', component: AddMunicipalities },
                        { path: 'Request/', component: Request },
                    ]
                },
            ],
        }
    ]
});

Vue.filter('toUpperCase', function (value) {
    if (!value) return '';
    return value.toUpperCase();
});

new Vue({
    router,
    render: h => {
        return h(App);
    }
}).$mount('#cpanel-management');
